import React, { useState } from 'react';

const susQuestions = [
  "I think that I would like to use this system frequently.",
  "I found the system unnecessarily complex.",
  "I thought the system was easy to use.",
  "I think that I would need the support of a technical person to be able to use this system.",
  "I found the various functions in this system were well integrated.",
  "I thought there was too much inconsistency in this system.",
  "I would imagine that most people would learn to use this system very quickly.",
  "I found the system very cumbersome to use.",
  "I felt very confident using the system.",
  "I needed to learn a lot of things before I could get going with this system."
];

interface SurveyFormProps {
  onSubmitSuccess: (score: number) => void;
}

export const SurveyForm: React.FC<SurveyFormProps> = ({ onSubmitSuccess }) => {
  const [answers, setAnswers] = useState<Record<number, number>>({});
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResponseChange = (questionId: number, value: number) => {
    setAnswers(prev => ({ ...prev, [questionId]: value }));
  };

  const calculateSUSScore = () => {
    let score = 0;
    for (let i = 0; i < 10; i++) {
      const answer = answers[i + 1];
      if (i % 2 === 0) { // Odd questions (1, 3, 5, 7, 9)
        score += answer - 1;
      } else { // Even questions (2, 4, 6, 8, 10)
        score += 5 - answer;
      }
    }
    return score * 2.5;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (Object.keys(answers).length !== 10) {
      setError("Please answer all 10 questions.");
      return;
    }
    setIsSubmitting(true);
    setError(null);

    const score = calculateSUSScore();

    try {
      const response = await fetch('/api/sus/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ score, answers }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit survey.');
      }

      onSubmitSuccess(score);
    } catch (err) {
      setError('An unexpected error occurred.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {susQuestions.map((question, index) => (
        <div key={index}>
          <p>{index + 1}. {question}</p>
          <div>
            {[1, 2, 3, 4, 5].map(value => (
              <label key={value}>
                <input
                  type="radio"
                  name={`question-${index + 1}`}
                  value={value}
                  onChange={() => handleResponseChange(index + 1, value)}
                  required
                />
                {value}
              </label>
            ))}
          </div>
        </div>
      ))}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Submitting...' : 'Submit'}
      </button>
    </form>
  );
};
